module.exports = __webpack_public_path__ + "img/left.d936cc58.png";